"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const next_components_text_info_n_1 = __importStar(require("@gerenciatd/next.components.text-info-n"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_icon_n_1 = __importDefault(require("@gerenciatd/next.components.icon-n"));
const constants_1 = require("../constants");
const utils_1 = require("./utils");
const TopBar = ({ segment, taggingInfo, isGestor, userType, userSegment, isPriority, fullName, isEmpleado, isBuyProcess, context, movistarMenuInfo, sectionMenu, }) => {
    if (!movistarMenuInfo) {
        return null;
    }
    let currentSectionMenu = sectionMenu;
    if (!userType) {
        currentSectionMenu = sectionMenu.public;
    }
    if (userType === constants_1.TELCO) {
        currentSectionMenu = sectionMenu.telco;
    }
    if (userType === constants_1.LEGADO) {
        currentSectionMenu = sectionMenu.legado;
    }
    const gestorOpts = {
        isGestor,
        context,
    };
    const optinalList2Render = (0, utils_1.createOptionListBy)(segment, gestorOpts, userType, fullName, userSegment);
    const cssPriority = segment === constants_1.PARTICULARES && isPriority && !isBuyProcess && !isGestor
        ? ` ${constants_1.PRIORITY}`
        : ' regular';
    const cssLogged = userType ? ' logged' : ' nologged';
    const cssSegment = ` ${segment}`;
    let segmentList2Render = [];
    if (!isGestor && segment === constants_1.EMPRESAS) {
        segmentList2Render = constants_1.SEGMENT_LIST_EMP;
    }
    if (!isGestor && segment === constants_1.PARTICULARES) {
        segmentList2Render = constants_1.SEGMENT_LIST_GP;
    }
    if ((isEmpleado || isBuyProcess) && !isGestor) {
        return (react_1.default.createElement("div", { className: `TopBar${cssPriority}${cssLogged}${cssSegment} fixedSize` }));
    }
    const cssIsGestor = isGestor ? ' Gestor' : '';
    if (currentSectionMenu && currentSectionMenu.type && currentSectionMenu.type === constants_1.LAYOUT_TYPES.BUY_PROCESS) {
        return null;
    }
    return (react_1.default.createElement("div", { className: `TopBar${cssPriority}${cssLogged}${cssSegment}${cssIsGestor}` },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "TopBarContainer" },
                react_1.default.createElement("div", { className: "OptionalList" }, optinalList2Render.map((item) => {
                    if (item.id === 'loginDetails') {
                        return (react_1.default.createElement("div", { key: item.id, className: "ItemList Login" },
                            react_1.default.createElement(next_components_text_info_n_1.default, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1, color: !isPriority ? item.color : 'white', text: item.label, segment: segment }),
                            item.svgId && (react_1.default.createElement("div", { className: "apagarTB" },
                                react_1.default.createElement(next_components_icon_n_1.default, { id: item.svgId, size: item.size, color: !isPriority ? item.color : 'white', kind: "L" }))),
                            react_1.default.createElement(next_components_custom_link_1.default, { key: item.id, role: "button", title: item.label, tabIndex: "-1", ariaLabel: item.label, taggingInfo: Object.assign(Object.assign(Object.assign({}, taggingInfo), item.taggingInfo), { componentVariation: `${userType}-${segment}` }), onClick: item.onClick })));
                    }
                    return (react_1.default.createElement("div", { key: item.id, className: "ItemList" },
                        react_1.default.createElement(next_components_custom_link_1.default, { component: "a", onClick: item.onClick, href: item.link, tabIndex: "-1", ariaLabel: item.label, title: item.label, taggingInfo: Object.assign(Object.assign(Object.assign({}, taggingInfo), item.taggingInfo), { componentVariation: `${userType}-${segment}` }), role: "button" },
                            react_1.default.createElement(next_components_text_info_n_1.default, { size: item.size ? item.size : next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION1, color: item.color, text: item.label, segment: segment }))));
                })),
                !userType && (react_1.default.createElement("div", { className: `SegmentsList${cssSegment}` }, segmentList2Render.map((item) => {
                    const isActive = segment === item.id;
                    let color = 'grey6';
                    if (segment === constants_1.PARTICULARES) {
                        color = isActive ? 'grey6' : 'grey4';
                    }
                    else {
                        color = isActive ? 'white' : 'grey2';
                    }
                    const printCheuron = (item.id === 'empresas' && segment === constants_1.PARTICULARES) ||
                        (item.id === 'particulares' && segment === constants_1.EMPRESAS);
                    return (react_1.default.createElement("div", { key: item.id, className: "ItemList" },
                        react_1.default.createElement(next_components_custom_link_1.default, { href: item.link, title: item.label, ariaLabel: item.label, taggingInfo: Object.assign(Object.assign(Object.assign({}, taggingInfo), item.taggingInfo), { componentContent: item.id }), role: "button", tabIndex: -1 },
                            react_1.default.createElement(next_components_text_info_n_1.default, { size: next_components_text_info_n_1.TEXT_INFO_SIZE.CAPTION3, color: color, text: item.label, segment: segment }),
                            printCheuron && (react_1.default.createElement("div", { className: "cheuronTB" },
                                react_1.default.createElement(next_components_icon_n_1.default, { id: "CheuronRight", size: 12, color: color }))))));
                })))))));
};
const mapStateToProps = (state) => ({
    isGestor: state.header.isGestor,
    segment: state.header.segment,
    userType: state.main.context.userType,
    userSegment: state.main.context.userSegment,
    fullName: state.main.context.userName,
    isPriority: state.main.context.userPriority,
    isEmpleado: state.header.isEmpleado,
    isBuyProcess: state.header.isBuyProcess,
    context: state.main.context,
    movistarMenuInfo: state.header.movistarMenuInfo,
    sectionMenu: state.header.sectionMenu,
});
const mapDispatchToProps = (dispatch) => ({
// handleSeveral: errorData => dispatch(errorActions.handleSeveral(errorData)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(TopBar);
//# sourceMappingURL=index.js.map